var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationSettingIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 6,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.811 21.75C17.811 21.8992 17.7517 22.0423 17.6462 22.1477C17.5407 22.2532 17.3977 22.3125 17.2485 22.3125H12.7485C12.5993 22.3125 12.4562 22.2532 12.3507 22.1477C12.2452 22.0423 12.186 21.8992 12.186 21.75C12.186 21.6008 12.2452 21.4577 12.3507 21.3523C12.4562 21.2468 12.5993 21.1875 12.7485 21.1875H17.2485C17.3977 21.1875 17.5407 21.2468 17.6462 21.3523C17.7517 21.4577 17.811 21.6008 17.811 21.75ZM21.5973 19.5C21.4997 19.6719 21.358 19.8147 21.1868 19.9136C21.0156 20.0125 20.8212 20.0639 20.6235 20.0625H9.37348C9.17572 20.0622 8.98152 20.0098 8.81046 19.9106C8.6394 19.8114 8.49752 19.6688 8.39913 19.4972C8.30073 19.3257 8.2493 19.1312 8.25001 18.9335C8.25072 18.7357 8.30355 18.5416 8.40317 18.3708C8.7934 17.6986 9.37348 15.7973 9.37348 13.3125C9.37348 11.8207 9.96611 10.3899 11.021 9.33502C12.0759 8.28013 13.5066 7.6875 14.9985 7.6875C16.4903 7.6875 17.9211 8.28013 18.976 9.33502C20.0309 10.3899 20.6235 11.8207 20.6235 13.3125C20.6235 15.7966 21.2043 17.6986 21.5945 18.3708C21.6951 18.5419 21.7483 18.7366 21.7487 18.9351C21.7491 19.1336 21.6966 19.3286 21.5966 19.5H21.5973ZM20.6235 18.9375C20.08 18.0045 19.4985 15.8473 19.4985 13.3125C19.4985 12.119 19.0244 10.9744 18.1805 10.1305C17.3365 9.28661 16.192 8.8125 14.9985 8.8125C13.805 8.8125 12.6604 9.28661 11.8165 10.1305C10.9726 10.9744 10.4985 12.119 10.4985 13.3125C10.4985 15.848 9.91629 18.0052 9.37348 18.9375H20.6235Z",
    fill: "#616E85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationSettingIcon3);
export default __webpack_public_path__ + "static/media/location_setting_icon3.25764db85222222ffd932043d71db11a.svg";
export { ForwardRef as ReactComponent };